import React from 'react';

const AISummaryError = ({ error }) => {
    return (
        <div className="ai-summary-container">
            <div className="ai-summary-card ai-summary-error">
                <div className="ai-summary-header">
                    <div className="ai-summary-icon">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="2"
                            />
                            <path
                                d="M12 8V12"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                            <circle cx="12" cy="16" r="1" fill="currentColor" />
                        </svg>
                    </div>
                    <h3>AI Summary Unavailable</h3>
                </div>
                <div className="ai-summary-content">
                    <p>{error}</p>
                </div>
            </div>
        </div>
    );
};

export default AISummaryError;
